import { request } from 'utils/requests'

const decodeVapidKey = value => {
  const padding = '='.repeat((4 - (value.length % 4)) % 4)
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/')
  const bytes = window.atob(base64)
  return Uint8Array.from(bytes, character => character.charCodeAt(0))
}

export const getPushPublicKey = async () => {
  const response = await request.get('/push/public-key')
  return response.data.publicKey
}

export const subscribeToPush = async registration => {
  const publicKey = await getPushPublicKey()
  if (!publicKey) throw new Error('Notificações móveis ainda não foram configuradas no servidor.')

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: decodeVapidKey(publicKey),
  })

  await request.post('/push/subscriptions', subscription.toJSON())
  return subscription
}

export const unsubscribeFromPush = async subscription => {
  await request.delete('/push/subscriptions', {
    data: { endpoint: subscription.endpoint },
  })
  await subscription.unsubscribe()
}
